import { Box, Typography } from "@mui/material";
import useGetBreakpoint from "../hooks/useGetBreakpoint";
import CustomAvatar from 'src/materio/@core/components/mui/avatar'
import { ReactNode } from "react";

type Props = {
    title: string,
    value: number | undefined,
    icon: ReactNode
}

const UXStatisticsBarItem = ({ title, value, icon }: Props) => {
    const { breakpoint } = useGetBreakpoint();

    return (
        <Box>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <CustomAvatar skin='light' variant='rounded' sx={{ mr: 3 }}>
                    {icon}
                </CustomAvatar>
                <Typography variant='subtitle1' sx={{ lineHeight: 1.3 }}>
                    {value ?? 0} {breakpoint !== 'xs' && breakpoint !== 'sm' && title}
                </Typography>
            </Box>
        </Box>
    )
}

export default UXStatisticsBarItem;